import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import './utils/axios';

import { Providers } from './providers';

import { App } from './App';
import { GlobalStyle } from './components/GlobalStyle';

ReactDOM.render(
  <React.Fragment>
    <Providers>
      <GlobalStyle />
      <Router>
        <Switch>
          <App />
        </Switch>
      </Router>
    </Providers>
  </React.Fragment>,
  document.getElementById('root')
);
